<div class="gh-siv-section">
  <div class="gh-siv-top-bar">
    <div class="gh-siv-title section-title">
      <ui-icon iconType="color:links" tooltipContent="{{ 'links' | localize }}" class="fs-16px"></ui-icon>
      <h3>{{ "related_items" | localize }}</h3>

      <div class="gh-siv-section-action">
        <!-- TODO: https://gtmhub.atlassian.net/browse/GVS-13052 -->
        <span class="link-accent">+ Add item</span>
      </div>
    </div>
  </div>
</div>
